"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentNodeType = void 0;
var DocumentNodeType;
(function (DocumentNodeType) {
    DocumentNodeType["FOLDER"] = "folder";
    DocumentNodeType["DOCUMENT"] = "document";
})(DocumentNodeType || (exports.DocumentNodeType = DocumentNodeType = {}));
//# sourceMappingURL=documentNodeType.enum.js.map